import React from 'react';
import './References.css';












const References = () => {
    return (
        <div className='References'>
            <div className="ReferencesWrapper">

                <a href="https://www.amc.info/de-de/">
                    <div>
                        AMC
                    </div>
                </a>



                <a href="https://www.globus.de">
                    <div>
                        Globus
                    </div>
                </a>

                <a href="https://www.aok.de">
                    <div>
                        AOK
                    </div>
                </a>



                <a href="https://www.barmer.de">
                    <div>
                        Barmer
                    </div>
                </a>

                <a href="https://www.db.de">
                    <div>
                        Deutsche Bahn
                    </div>
                </a>
                <a href="https://www.rag.de">
                    <div>
                        RAG - Deutsche Steinkohle
                    </div>
                </a>
                <a href="https://www.thyssenkrupp.com">
                    <div>
                        Thyssenkrupp
                    </div>
                </a>

                <a href="https://www.tk.de">
                    <div>
                        Techniker Krankenkasse
                    </div>
                </a>

                <a href="https://www.volkshochschule.de">
                    <div>
                        Volkshochschule
                    </div>
                </a>

                <a href="https://www.villeroy-boch.de">
                    <div>
                        Villeroy und Boch
                    </div>
                </a>

            </div >
        </div>);

}



export default References;